import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { branding } from '../../config/branding';
import { CustomSyncService } from '../../services/custom-sync.service';

@Component({
  selector: 'app-paused-overlay',
  standalone: true,
  templateUrl: './paused-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './paused-overlay.component.css',
})
export class PausedOverlayComponent {
  private syncService = inject(CustomSyncService);
  protected readonly appName = branding.appName;

  requestLeadership(): void {
    this.syncService.requestLeadership();
  }
}
